import React from 'react';
import CreateNewBusinessForm from '@/components/forms/CreateNewBusinessForm';

export const CreateNewBusinessPage = () => {
	return <CreateNewBusinessForm />;
};
